export default "__VITE_ASSET__CGMiaCMG__"